/* eslint-disable func-style, consistent-return, no-underscore-dangle */
const fixedSide = function(elt) {
  if (elt === undefined) {
    return false;
  }
  function _createFixed() {
    if (window.innerWidth > 998) {
      const side = $(elt).css({
        position: 'static', left: 0, top: 0, margin: ''
      });
      if (side.length) {
        const sideY = side.offset().top;
        const sideX = side.offset().left;

        if (window.pageYOffset > (sideY - 10) &&
          (window.innerHeight - (side.height() + 10)) >= ($('#footer').height())) {
          side.css({
            position: 'fixed', left: sideX, top: '10px', margin: 0
          });
        } else {
          side.css({
            position: 'static', left: 0, top: 0, margin: ''
          });
        }
      }
    } else {
      $(elt).css({
        position: 'static', left: 0, top: 0, margin: ''
      });
    }
  }

  window.DR.pubsub.on('resize', _createFixed);
  window.DR.pubsub.on('scroll', _createFixed);
  _createFixed();
};

module.exports = fixedSide;
